/** Set to `'done'` after the first successful `/api/users/me` in this browser tab (see `loadAppUserProfile`). */
export const APP_ME_BOOTSTRAP_KEY = 'appMeBootstrap';

export const APP_USER_NEEDS_ONBOARDING_KEY = 'appUserNeedsOnboarding';

export function isAppMeBootstrapDone(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  return sessionStorage.getItem(APP_ME_BOOTSTRAP_KEY) === 'done';
}

export function isAppUserInOnboardingFlow(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  return sessionStorage.getItem(APP_USER_NEEDS_ONBOARDING_KEY) === '1';
}
